module.exports = __webpack_public_path__ + "static/taxonomy-highlights-88fa95b8e67d612b2b709bd07ea291b9.gif";